var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BFormRadioGroup } from 'bootstrap-vue';
import FrameStyleSlider from 'components/standard-size-picture-frames/FrameStyleSlider.vue';
let RangesSearchForm = class RangesSearchForm extends Vue {
    constructor() {
        super(...arguments);
        this.priceOptions = [
            { text: 'Any', value: 'any' },
            { text: 'Budget', value: 'budget' },
            { text: 'Standard', value: 'standard' },
            { text: 'Premium', value: 'premium' }
        ];
    }
};
__decorate([
    ModelSync('filters', 'change', { type: Object })
], RangesSearchForm.prototype, "selectedFilters", void 0);
RangesSearchForm = __decorate([
    Component({
        components: {
            BRow, BCol, BFormGroup, BFormRadioGroup,
            FrameStyleSlider
        }
    })
], RangesSearchForm);
export default RangesSearchForm;
